import { useCallback, useMemo, useState } from 'react';
import { useBreakpoint } from '@distribusion/portal-lib/responsive';
import { Layout, MenuProps } from 'antd';
import { PartnersPreferences } from 'features/settings/api/preferences';

import { SideNavContent } from './side-nav-content';
import { SideNavDrawer } from './side-nav-drawer';
import { Trigger } from './trigger';

interface SideNavProps {
  mobileNavOpened: boolean;
  onCloseMobileNav: () => void;
  menuProps: MenuProps;
  preferences?: PartnersPreferences;
}

const AMADEUS_PARTNER_IDS = ['983088', '753361'];

export const SideNav = ({
  mobileNavOpened,
  onCloseMobileNav,
  menuProps,
  preferences,
}: SideNavProps) => {
  const [collapsed, setCollapsed] = useState(false);
  const { lg } = useBreakpoint();
  const handleTriggerClick = useCallback(() => setCollapsed(!collapsed), [collapsed, setCollapsed]);

  const shouldHideFooterLogo = useMemo(
    () => AMADEUS_PARTNER_IDS.includes(preferences?.partner_id),
    [preferences?.partner_id],
  );

  if (lg) {
    return (
      <>
        {/* Fake Sider needed for taking space for "fixed" one */}
        <Layout.Sider collapsed={collapsed} width={244} />
        <Layout.Sider
          collapsible
          collapsed={collapsed}
          width={244}
          breakpoint="xl"
          trigger={null}
          onCollapse={setCollapsed}
          style={{ position: 'fixed' }}
        >
          <Trigger collapsed={collapsed} onClick={handleTriggerClick} />
          <SideNavContent
            collapsed={collapsed}
            menuProps={menuProps}
            baseLogoUrl={preferences?.default_logo_url}
            secondLogoUrl={preferences?.second_logo_url}
            shouldHideFooterLogo={shouldHideFooterLogo}
          />
        </Layout.Sider>
      </>
    );
  }

  return (
    <SideNavDrawer
      maskClosable
      closable={false}
      width={244}
      placement="left"
      onClose={onCloseMobileNav}
      open={mobileNavOpened}
    >
      <SideNavContent
        collapsed={collapsed}
        menuProps={menuProps}
        baseLogoUrl={preferences?.default_logo_url}
        secondLogoUrl={preferences?.second_logo_url}
        shouldHideFooterLogo={shouldHideFooterLogo}
      />
    </SideNavDrawer>
  );
};
